import React from 'react';

import {
  FAMILY_STANDARD_BOLD,
  FAMILY_EXTENDED_BOLD,
} from 'depop/styles/typography';

import { css } from 'glamor';

function HeaderMenuItem({
  children,
  expanded = false,
}: {
  children: React.Element,
  expanded: boolean,
}) {
  return React.cloneElement(
    children,
    css({
      display: 'block',
      fontSize: 16,
      lineHeight: '20px',
      color: 'inherit',
      textDecoration: 'none',
      fontWeight: 'bold',
      fontFamily: expanded ? FAMILY_EXTENDED_BOLD : FAMILY_STANDARD_BOLD,
      cursor: 'pointer',
      ':hover': {
        textDecoration: 'underline',
      },
    }),
  );
}

export default HeaderMenuItem;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/HeaderMenuItem.js